import "./index.scss";
import "../../locales/i18n";

import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { SimpleDropdown } from "@/components/components/Dropdown";
import { TDropdownOption } from "@/components/components/Dropdown/dropdown.type";
import { useSelector } from "react-redux";
import { deviceTypeSelector } from "src/ducks/selectors/general";
import { detectMobile } from "src/utils/deviceType";

interface TRepDropdownProps {
    options: TDropdownOption[];
    currentUser: string;
    onSelectRepresentative: (representativeId: string) => void
}

export default function RepDropdown({ options, currentUser, onSelectRepresentative }: TRepDropdownProps): ReactElement {
    const deviceType = useSelector(deviceTypeSelector);
    const isMobile = detectMobile(deviceType);

    const headerText = `${currentUser}`;

    const { t } = useTranslation();

    const onSelect = (o: TDropdownOption) => {
        onSelectRepresentative(o.label);
    };

    return (
        <div className="c-rep-dropdown" role="form">
            <>
                <SimpleDropdown
                    isMobileView={isMobile}
                    multiple={false}
                    className="c-first-login__dropdown"
                    dropdownDefaultRenderClassNames={{ header: "c-first-login__dropdown-header" }}
                    heading={headerText}
                    onSelect={onSelect}
                    options={options}
                    search={false}
                    ariaLabel={t("Representative Filter")}
                />
            </>
        </div>
    );
}